import React, { useRef } from "react";
import { Area } from "@ant-design/charts";

const basic = {
	xField: "key",
	yField: "value",
	xAxis: {
		tickCount: 5,
	},
	autoFit: true,
};

const slider = {
	start: 0.1,
	end: 0.7,
};

const point = {
	size: 5,
	shape: "diamond",
};

const label = {};
const smooth = true;
const seriesField = "type";
const legend = {
	position: "top",
};
const isStack = true;

export default function AreaChart(chartData = [], chartConfig = {}) {
	const config = {
		data: chartData,
		...basic,
		point: chartConfig.point ? point : false,
		label: chartConfig.label ? label : false,
		slider: chartConfig.slider ? slider : false,
		smooth: chartConfig.smooth ? smooth : false,
		isStack: chartConfig.isStack ? isStack : false,
		seriesField: chartConfig.isStack ? seriesField : false,
		legend: chartConfig.legend ? legend : false,
	};
	const ref = useRef();

	return <Area {...config} chartRef={ref} />;
}
